import axios from "axios";
import { useEffect, useState } from "react";
import auth from "../auth/auth";
import NotAuthorized from "./NotAuthorized";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CommunityComments = () => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(true);
  const login = (JSON.parse(localStorage.getItem("user")) || {}).login;

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API}/commentaires`, { headers: auth() })
      .then((res) => {
        setComments(res.data);
      })
      .catch((error) => {
        console.log("Erreur lors de la récupération des commentaires");
        toast.error("Erreur lors de la récupération des commentaires.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!newComment.trim()) {
      toast.warn("Veuillez entrer un commentaire.");
      return;
    }

    const formcomment = {
      text: newComment,
    };

    axios.post(`${process.env.REACT_APP_API}/comments`, formcomment, { headers: auth() })
      .then((res) => {
        setComments((prevComments) => [res.data, ...prevComments]);
        setNewComment("");
        toast.success("Commentaire ajouté avec succès !");
      })
      .catch((error) => {
        console.log("Erreur lors de l'ajout du commentaire :");
        toast.error("Erreur lors de l'ajout du commentaire.");
      });
  };

  if (!login) {
    return <NotAuthorized />;
  }

  return (
    <main className="comments">
      <h1 className="heading">Communauté - Espace de Commentaires</h1>

      <section className="community-comments">
        <form onSubmit={handleSubmit} method="post" className="comment-form">
          <input
            type="text"
            placeholder="Votre nom"
            value={login}
            readOnly
          />
          <textarea
            placeholder="Ajoutez un commentaire..."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
          />
          <button type="submit" disabled={loading}>Ajouter un commentaire</button>
        </form>

        {loading ? <p>Chargement des commentaires...</p> : (
          <section className="comment-list">
            {comments.map((comment) => (
              <div key={comment._id} className="comment">
                <p><strong>{comment.author}</strong>: {comment.text}</p>
                <small>Posté le {new Date(comment.createdAt).toLocaleDateString()}</small>
              </div>
            ))}
          </section>
        )}
      </section>
    </main>
  );
};

export default CommunityComments;
